"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailActionbarButton = exports.SecondaryDetailActionbarButton = exports.PrimaryDetailActionbarButton = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const tooltip_1 = require("../../components/tooltip/tooltip");
const detail_context_1 = require("./detail-context");
const detail_types_1 = require("./detail-types");
const useStyles = (0, makeStyles_1.default)({
    actionbarButton: {
        // height: 25,
        minWidth: 40,
        width: 'max-content',
        cursor: 'pointer',
        // padding: '0px 10px',
        marginTop: 1,
        marginLeft: 6,
        backgroundColor: '#e0e0e0',
        border: 0,
        // textTransform: 'none',
        '&:hover': {
            backgroundColor: '#d0d0d0',
        },
    },
    actionbarMainButton: {
        // height: 25,
        minWidth: 40,
        whiteSpace: 'nowrap',
        width: 'max-content',
        cursor: 'pointer',
        // padding: '0px 10px',
        marginTop: 1,
        marginLeft: 6,
        border: 0,
        // textTransform: 'none',
        boxShadow: '0 0 0',
        color: 'white',
    },
});
function PrimaryDetailActionbarButton(props) {
    return (react_1.default.createElement(DetailActionbarButton, { ...props, type: detail_types_1.DetailToolbarButtonType.PRIMARY }));
}
exports.PrimaryDetailActionbarButton = PrimaryDetailActionbarButton;
function SecondaryDetailActionbarButton(props) {
    return (react_1.default.createElement(DetailActionbarButton, { ...props, type: detail_types_1.DetailToolbarButtonType.SECONDARY }));
}
exports.SecondaryDetailActionbarButton = SecondaryDetailActionbarButton;
function DetailActionbarButton({ label, tooltip, disabled, onClick, href, type = detail_types_1.DetailToolbarButtonType.NORMAL, startIcon, endIcon, buttonType, isLocked, ...restProps }) {
    var _a;
    const classes = useStyles();
    const detailCtx = (0, react_1.useContext)(detail_context_1.DetailContext);
    const locked = !!((_a = detailCtx === null || detailCtx === void 0 ? void 0 : detailCtx.entityLocking) === null || _a === void 0 ? void 0 : _a.lockedByUser) ||
        (isLocked !== undefined ? isLocked : !!(detailCtx === null || detailCtx === void 0 ? void 0 : detailCtx.isLocked));
    const buttonProps = { ...restProps };
    if (type === detail_types_1.DetailToolbarButtonType.PRIMARY) {
        buttonProps.color = 'primary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.actionbarMainButton };
    }
    else if (type === detail_types_1.DetailToolbarButtonType.SECONDARY) {
        buttonProps.color = 'secondary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.actionbarMainButton };
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, disabled || locked ? (react_1.default.createElement(Button_1.default, { type: buttonType, onClick: onClick, href: href, disabled: true, variant: "outlined", size: "small", classes: { root: classes.actionbarButton }, ...buttonProps, startIcon: startIcon, endIcon: endIcon },
        react_1.default.createElement(Typography_1.default, { variant: "body2" }, label))) : (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "top-start" },
        react_1.default.createElement(Button_1.default, { type: buttonType, onClick: onClick, href: href, disabled: disabled, variant: "outlined", size: "small", classes: { root: classes.actionbarButton }, ...buttonProps, startIcon: startIcon, endIcon: endIcon },
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, label))))));
}
exports.DetailActionbarButton = DetailActionbarButton;
//# sourceMappingURL=detail-actionbar-button.js.map